<template>
  <button
    :disabled="submitting || disabled"
    :type="type"
    class="btn -std -tag video-tag"
    :class="classes"
    @click.prevent="handleClick"
  >
    <!-- {{ submitting ? submittingLabel : label }} -->
    <span class="btn-txt">{{ label }}</span>
    <i v-show="showIcon" class="material-icons-outlined md-light btn-ico">{{ icon }}</i>
  </button>
</template>

<script>
export default {
  name: 'TagButton',
  props: {
    submitting: Boolean,
    disabled: Boolean,
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
    submittingLabel: {
      type: String,
      default: 'Saving...',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: 'close',
    },
    classes: {
      type: String,
      default: '',
    },
  },

  // instance methods
  methods: {
    handleClick(event: MouseEvent) {
      this.$emit('click-action', event)
    },
  },
}
</script>
